export default {
	data() {
		return {
			actions: [],
			optionsData: []
		};
	},
	computed: {
		isSmallDevice() {
			return this.screenSize.mobile || this.screenSize.smallTablet;
		}
	},
	methods: {
		renderActions(items, isSmallDevice) {
			let results = [...items];

			if (results.length > 3 && isSmallDevice) {
				let moreItems = results.splice(3, results.length);
				results.push({
					id: results.length + 1,
					action: '#',
					disabled: false,
					iconClass: 'icon icon-menu',
					label: 'More',
					title: 'Select to see the more actions',
					type: 'dropdown',
					visible: true,
					items: moreItems
				});
			}

			this.optionsData = results;
		}
	},
	watch: {
		isSmallDevice: {
			immediate: true,
			handler(val) {
				this.renderActions(this.actions, val);
			}
		},
		actions: {
			immediate: true,
			handler(val) {
				this.renderActions(val, this.isSmallDevice);
			}
		}
	}
};
